import { render } from "./ProductDetailsPage.vue?vue&type=template&id=3986982e"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"

import "./ProductDetailsPage.vue?vue&type=style&index=0&id=3986982e&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__